var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1865 6.24046L14.0949 1.33203M14.0949 1.33203H10.1682M14.0949 1.33203L14.0949 5.25878M6.24144 6.24046L1.33301 1.33203M1.33301 1.33203H5.25975M1.33301 1.33203V5.25878M9.1865 9.18552L14.0949 14.094M14.0949 14.094L10.1682 14.094M14.0949 14.094L14.0949 10.1672M6.24144 9.18552L1.33301 14.094M1.33301 14.094L5.25975 14.094M1.33301 14.094V10.1672",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/ExpandIcon.ab2926952470fc2c0fceb939eeee1a4d.svg";
export { ForwardRef as ReactComponent };